import axios from "axios";
import apiUrlOne from "../../utils.js/Config";


//  Fetch all country codes (flags)

export const getAllFlags = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/country-codes/admin`);
        return response.data;
    } catch (error) {
        console.error("Error fetching country codes:", error);
        throw error;
    }
};

/* Create a new country code*/
export const createFlag = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/country-codes`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating country code:", error);
        throw error;
    }
};

/* Update an existing country code*/
export const updateFlag = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/country-codes/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating country code with ID ${id}:`, error);
        throw error;
    }
};

/* Delete a country code*/
export const deleteFlag = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/country-codes/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting country code with ID ${id}:`, error);
        throw error;
    }
};